import { complianceCheckUrl } from 'entities/Compliance'

export const COMPLIANCE_URL_ERROR_MESSAGE = 'The URL you entered could not be reached.'
export const COMPLIANCE_URL_WARNING_MESSAGE =
  "Couldn't verify this link automatically. You can still continue — make sure it opens publicly."
export const COMPLIANCE_URL_SUCCESS_MESSAGE = ''

type IComplianceUrlField = {
  value: string
  setValue: (url: string) => void
  setError: (message: string) => void
  setWarning?: (message: string) => void
  setSuccess?: (message: string) => void
}

type ICheckComplianceUrlsParams = {
  privacyPolicyUrl: IComplianceUrlField
  termsUrl: IComplianceUrlField
}

export const checkComplianceUrls = async (params: ICheckComplianceUrlsParams) => {
  const privacyUrl = params.privacyPolicyUrl.value.trim()
  const termsUrl = params.termsUrl.value.trim()

  if (!privacyUrl && !termsUrl) {
    return true
  }

  const [privacyResult, termsResult] = await Promise.all([
    complianceCheckUrl(privacyUrl),
    complianceCheckUrl(termsUrl),
  ])

  let isValid = true

  if (privacyUrl) {
    if (!privacyResult.isError) {
      params.privacyPolicyUrl.setValue(privacyResult.url)

      if (privacyResult.isWarning) {
        params.privacyPolicyUrl.setWarning?.(COMPLIANCE_URL_WARNING_MESSAGE)
      }

      if (privacyResult.isSuccess) {
        params.privacyPolicyUrl.setSuccess?.(COMPLIANCE_URL_SUCCESS_MESSAGE)
      }
    } else {
      params.privacyPolicyUrl.setError(COMPLIANCE_URL_ERROR_MESSAGE)
      isValid = false
    }
  }

  if (termsUrl) {
    if (!termsResult.isError) {
      params.termsUrl.setValue(termsResult.url)

      if (termsResult.isWarning) {
        params.termsUrl.setWarning?.(COMPLIANCE_URL_WARNING_MESSAGE)
      }

      if (termsResult.isSuccess) {
        params.termsUrl.setSuccess?.(COMPLIANCE_URL_SUCCESS_MESSAGE)
      }
    } else {
      params.termsUrl.setError(COMPLIANCE_URL_ERROR_MESSAGE)
      isValid = false
    }
  }

  return isValid
}
